export const RoadLoadTypes = {
  IRoadLoadService: Symbol("IRoadLoadService"),
};
